import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer>
      <p>
        © {new Date().getFullYear()} Synergistic Intelligence® · All rights
        reserved.
      </p>

      <div className="footer-links">
        <a
          href="https://substack.com/@synergisticvision"
          target="_blank"
          rel="noreferrer"
        >
          Substack
        </a>

        <a
          href="https://www.linkedin.com/company/synergistic-intelligence/"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn
        </a>

        <a
          href="https://open.spotify.com/show/5sIwpUFFsbC0rAMH4F5MW0"
          target="_blank"
          rel="noreferrer"
        >
          Podcast
        </a>

        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
      </div>
    </footer>
  );
}